const backInStockForms = document.querySelectorAll('[data-notification-form]');

const handleBackInStockSubscriptions = (forms) => {
  forms?.forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();

      const variant = form.dataset.variantId;
      const formData = new FormData(form);
      const submittedEmail = formData.get('contact[email]');

      const klaviyoFormData = new FormData();
      klaviyoFormData.set('email', submittedEmail);
      klaviyoFormData.set('platform', 'shopify');
      klaviyoFormData.set('a', 'Vs6wgP');
      klaviyoFormData.set('variant', variant);

      // Define the URL and the data we are going to send
      const url = 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe';

      const formDataEntries = new URLSearchParams();
      for (let [key, value] of klaviyoFormData.entries()) {
        formDataEntries.append(key, value);
      }

      // Set up HTTP request
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataEntries,
        mode: 'cors',
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json(); // or .text() or .blob() etc., depending on the response type you expect
        })
        .then((data) => {
          console.log(data); // Process the success response
          form.submit();
        })
        .catch((error) => {
          console.error('Fetch error:', error.message);
          form.submit();
        });
    });
  });
};

handleBackInStockSubscriptions(backInStockForms, '');
